import React, { useState } from "react";
import styles from "./PageHeaderCard.module.scss";
import Image from "next/image";
import { zodiacDataType } from "../../Enum";

interface PageHeaderCardProps {
  activeLogo?: zodiacDataType;
  title: string;
  subTitle: string;
  location?: string;
}

const PageHeaderCard = ({
  activeLogo,
  title,
  subTitle,
  location,
}: PageHeaderCardProps) => {
  return (
    <div className={styles.nameCard}>
      <div className={activeLogo?.logo.length ? `${styles.logoWrapper}` : ``}>
        {activeLogo?.logo.length && (
          <Image
            src={activeLogo?.logo as string}
            alt="logo"
            height={44}
            width={44}
          />
        )}
      </div>
      <div
        className={
          activeLogo?.logo.length
            ? `${styles.activeLogo}`
            : `${styles.textWrapper}`
        }
      >
        <h4>
          {activeLogo?.name} {title}
        </h4>
        <p>
          {subTitle} {location && `| ${location}`}
        </p>
      </div>
    </div>
  );
};

export default PageHeaderCard;
